import { Tooltip } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';

function OverflowFileName({ fileName, className = '', onClick = null }) {
    const textRef = useRef(null);
    const [isOverflow, setIsOverflow] = useState(false);

    const checkOverflow = useCallback(() => {
        const el = textRef.current;
        if (!el) return;
        // Both widths are 0 while the element is hidden, keep the last known value instead of dropping the tooltip.
        if (el.clientWidth === 0 && el.scrollWidth === 0) return;
        setIsOverflow(el.scrollWidth > el.clientWidth);
    }, []);

    useEffect(() => {
        const el = textRef.current;
        const observer = new ResizeObserver(() => checkOverflow());

        if (el) {
            checkOverflow();
            observer.observe(el);
            if (el.parentElement) observer.observe(el.parentElement);
        }

        return () => observer.disconnect();
    }, [checkOverflow, fileName]);

    const content = (
        <span ref={textRef} className={className} onClick={onClick}>
            {fileName}
        </span>
    );

    if (!isOverflow) return content;

    return (
        <Tooltip title={fileName} placement="top" arrow>
            {content}
        </Tooltip>
    );
}

OverflowFileName.propTypes = {
    fileName: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func
};

export default OverflowFileName;
